<script>
import Wysiwyg from '@wielink-application/shared/vue/components/form/horizontal/wysiwyg.vue';

export default Wysiwyg;
</script>